const storename = 'WalmartCheckout';

// Actions
export const SET_AFFILATE_URI = `${storename}/SET_AFFILIATE_URI`;
export const SET_GOTO_URI = `${storename}/SET_GOTO_URI`;
export const SET_LOCATION = `${storename}/SET_LOCATION`;
export const ADD_PRODUCT = `${storename}/ADD_PRODUCT`;
export const REMOVE_PRODCUT = `${storename}/REMOVE_PRODUCT`;
export const SET_PRODUCTS = `${storename}/SET_PRODUCTS`;

export const MUT_SET_LOCATION = `${storename}/MUT_SET_LOCATION`;
export const MUT_SEND_TELEMTRY = `${storename}/MUT_SEND_TELEMTRY`;


// Getters
export const GET_NUM_OF_PRODUCTS = `${storename}/GET_NUM_OF_PRODUCTS`;
export const GET_PRICE = `${storename}/GET_PRICE`;
export const GET_CHECKOUT_URI = `${storename}/GET_CHECKOUT_URI`;
export const GET_LOCATION = `${storename}/GET_LOCATION`;
